import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import theme from './styles/theme';
import AppRoutes from './routes/AppRoutes';
import AdminRoutes from './routes/AdminRoutes';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import GlobalStyle from './styles/global';
import { AuthProvider } from './contexts/AuthContext';
import { NewsletterProvider } from './contexts/NewsletterContext';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/AnalyticsTracker';
import './styles/admin.css';

const App: React.FC = () => {
  // Global error handler for unhandled promise rejections
  React.useEffect(() => {
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error('Unhandled promise rejection:', event.reason);
      // Prevent the error from showing in console in production
      if (process.env.NODE_ENV === 'production') {
        event.preventDefault();
      }
    };

    const handleError = (event: ErrorEvent) => {
      console.error('Global error:', event.error);
      // Prevent default error handling in production
      if (process.env.NODE_ENV === 'production') {
        event.preventDefault();
      }
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleError);
    };
  }, []);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Router>
          <ScrollToTop />
          <AnalyticsTracker />
          <AuthProvider>
            <NewsletterProvider>
              <Routes>
                {/* Admin Routes */}
                <Route path="/admin/*" element={<AdminRoutes />} />
                {/* Public Routes */}
                <Route
                  path="/*"
                  element={
                    <>
                      <AppRoutes />
                      <WhatsAppButton />
                    </>
                  }
                />
              </Routes>
            </NewsletterProvider>
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
